import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=07d9f8a0&scoped=true&"
import script from "./TheFooter.vue?vue&type=script&lang=js&"
export * from "./TheFooter.vue?vue&type=script&lang=js&"
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=07d9f8a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d9f8a0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterContent: require('/var/www/app/components/footer/FooterContent.vue').default,FooterIcons: require('/var/www/app/components/footer/FooterIcons.vue').default})
